import MainLayout from "@/components/layout/company/MainLayout.vue";
import TwspNameJson from "@/assets/json/township.json";
import RegionJson from "@/assets/json/region.json";
import { required, email, maxLength, minLength, numeric } from "vuelidate/lib/validators";
import axios from "axios";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "companyDashboardUpdate",
    
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            isLoading: false,
            fullPage: true,
            isEditForm: true,
            submitted: false,
            company_logo: "",
            company: {
                company_logo: "",
                company_name: "",
                email: "",
                phone_number: "",
                address: "",
                town: "",
                region: "",
                company_detail: "",
                agency: 0
            },
            error_email: "",
            regionArr: RegionJson,
            selectedTwspName: "",
            twspNameJson: TwspNameJson,
            twspName: [],
            isRegionDropdownOpen: false,
            isTownDropdownOpen: false
        };
    },

    computed: {
        selectedRegionName() {
            if (this.company.region === '' || this.company.region === null || this.company.region === undefined) return '';
            return this.regionArr[this.company.region] || '';
        }
    },

    validations: {
        company: {
            company_name: {
                required,
                maxLength: maxLength(100)
            },
            email: {
                required,
                email
            },
            phone_number: {
                required,
                minLength: minLength(9),
                maxLength: maxLength(11),
                numeric
            },
            region: {
                required
            },
            town: {
                required
            }
        }
    },

    methods: {
        onChange(event) {
            var Value = event.target.value;
            this.company.region = Value;
            this.selectedTwspName = "";
            this.company.town= "";
            this.twspName = this.changeTwspName(Value);
        },

        changeTwspName(value, twspName) {
            twspName = this.twspNameJson[value];
            return twspName;
        },

        onChangeTwspName(event) {
            var Value = event.target.value;
            this.company.town = Value;
        },

        onProfileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return null;

            // Enforce size limit under 2MB (2 * 1024 * 1024 bytes)
            if (files[0].size > 2097152) {
                this.$notification.error("ပုံအရွယ်အစားသည် 2MB ထက်မကျော်ရပါ။", {
                    timer: 3,
                    position: "bottomCenter"
                });
                e.target.value = "";
                return;
            }

            this.company_logo = e.target.files[0];
            let reader = new FileReader();
            reader.onload = e => {
                this.company_logo = e.target.result;
                this.company.path = e.target.result;
            };
            reader.readAsDataURL(files[0]);
        },

        handleSubmit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.updateCompany();
        },

        showCompanyUpdate() {
            axios.get("/company/dashboard/update/" + this.$route.params.id)
                .then(response => {
                    this.company = response.data;
                    this.oldRegion = response.data.region;
                    this.twspName = this.changeTwspName(this.company.region);
                    if (this.company.agency == 1) {
                        this.company.agency = true;
                    } 
                    if (this.company.agency == 0) {
                        this.company.agency = false;
                    }
                })
                .catch(error => {
                    console.log("Company Update API Error", error);
                });
        },

        updateCompany() {
            this.isLoading = true;
            var request = {
                id: this.company.id,
                company_name: this.company.company_name,
                email: this.company.email,
                phone_number: this.company.phone_number,
                address: this.company.address,
                town: this.company.town,
                region: this.company.region,
                company_detail: this.company.company_detail,
                agency: this.company.agency
            };

            if (this.company_logo.length < 10000000) {
                request.company_logo = this.company_logo;
                request.old_company_logo = this.company.company_logo;
            } else {
                request.company_logo = null;
                request.old_company_logo = null;
            }

            axios.post("/company/dashboard/updated", request)
            .then(response=> {
                if (response.data.error_msg) {
                    this.image_size = response.data.msg;
                    this.isLoading = false;
                    this.$notification.error("သတ်မှတ်ထားသော ပုံအရွယ်အစားထက်ကြီးနေပါတယ်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                } else if (response.data.msg) {
                    this.error_email = response.data.msg;
                    this.isLoading = false;
                    this.$notification.error(response.data.msg, {
                        timer: 3,
                        position: "bottomCenter"
                    });
                } else {
                    this.$notification.success("အချက်အလက်များ ပြောင်းလဲခြင်း အောင်မြင်သည်။", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.isLoading = false;
                    setTimeout(() => this.$router.push({
                        path: "/company/dashboard/" + this.$route.params.id
                    }), 2000);
                }
            })
            .catch(error => {
                this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                    timer: 3,
                    position: "bottomCenter"
                });
                this.isLoading = false;
                console.log("Edit Company Error", error);
            });
        },

        toggleRegionDropdown() {
            this.isRegionDropdownOpen = !this.isRegionDropdownOpen;
            this.isTownDropdownOpen = false;
        },

        selectRegion(id) {
            this.company.region = id;
            this.isRegionDropdownOpen = false;
            this.company.town = "";
            this.twspName = this.changeTwspName(id);
        },

        toggleTownDropdown() {
            this.isTownDropdownOpen = !this.isTownDropdownOpen;
            this.isRegionDropdownOpen = false;
        },

        selectTown(value) {
            this.company.town = value;
            this.isTownDropdownOpen = false;
        },

        handleOutsideClick(e) {
            if (!e.target.closest('.custom-select-wrapper')) {
                this.isRegionDropdownOpen = false;
                this.isTownDropdownOpen = false;
            }
        }
    },

    mounted() {
        this.showCompanyUpdate();
        window.addEventListener('click', this.handleOutsideClick);
    },

    beforeDestroy() {
        window.removeEventListener('click', this.handleOutsideClick);
    }
};
